module.exports = __webpack_public_path__ + "static/funds-c60e1bb2988acd36dc604ef2736f861d.svg";